export const buildWellbeingWorkflowStorageKey = (workspaceId?: string) =>
  `wellbeing:selectedWorkflow:${workspaceId ?? "default"}`;

export const getStoredWellbeingWorkflowId = (
  workspaceId?: string,
  storage: Pick<Storage, "getItem"> = window.localStorage
) => {
  const key = buildWellbeingWorkflowStorageKey(workspaceId);
  return storage.getItem(key) ?? undefined;
};

export const setStoredWellbeingWorkflowId = (
  workspaceId: string | undefined,
  workflowId: string | undefined,
  storage: Pick<Storage, "setItem" | "removeItem"> = window.localStorage
) => {
  const key = buildWellbeingWorkflowStorageKey(workspaceId);
  if (!workflowId) {
    storage.removeItem(key);
    return;
  }
  storage.setItem(key, workflowId);
};
